import { useUserEventLogger } from '@repo/tracking-service';
import { LottiePlayer } from '@repo/ui';
import { List, Title } from '@zenterprise-inc/ui';

import { SlotTargetType, SlotType, AD_SLOT_RESOURCE_CENTER_URL } from '@/lib/constants/ad-slots';
import { useAdSlots } from '@/lib/hooks/use-ad-slots';

export const SummaryBottomBanner = ({ slot, corpType, title }: { slot: SlotType; corpType: SlotTargetType; title: string }) => {
  const { sendClickEvent } = useUserEventLogger();
  const { slots, handleRouteChange } = useAdSlots(slot, corpType);

  if (!slots.length) return null;
  return (
    <div>
      <Title.Section title={title} size="small" />
      <div className={'rounded-5 flex flex-col overflow-hidden bg-gray-50 py-2'}>
        {slots.map(({ items, title }) => {
          const item = items?.[0];
          const imagePath = `${AD_SLOT_RESOURCE_CENTER_URL}/${item?.imagePath}`;
          return (
            <div
              key={title}
              className={'rounded-4 cursor-pointer px-6 py-1 duration-150 ease-in-out hover:scale-[0.97] hover:bg-gray-100'}
              onClick={() => {
                if (item?.userEvent) sendClickEvent(item.userEvent);
                handleRouteChange(item?.linkUrl ?? '');
              }}
            >
              <List.Basic
                title={{ text: item?.displayTitle ?? '', titleStyle: 'headline-16' }}
                overText={{ text: item?.description ?? '', color: 'gray.700' }}
                left={
                  imagePath.endsWith('json') ? (
                    <div className={'w-10 h-10'}>
                      <LottiePlayer src={imagePath} loop={true} autoPlay={true} />
                    </div>
                  ) : (
                    <img src={imagePath} width={40} height={40} alt={imagePath} />
                  )
                }
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
